'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var IndexSection = require('components/IndexSection/IndexSection');

require('./IndexMoments.less');


module.exports = IndexSection.extend({

    //is next section on show animation lies under or moves from outside
    NEXT_SECTION_MOVE: true,

    el: '.IndexMoments',

    events: _.extend({}, IndexSection.prototype.baseEvents),


    initialize: function (options) {
        _.bindAll(this, 'onResize', 'onResourcesReady', 'onVideoCanPlay');

        this.resources = {};

        var deviceSuffix = '';

        if (app.settings.isTablet) {
            deviceSuffix = '_tablet';
        }

        if (app.settings.isPhone) {
            deviceSuffix = '_phone';
        }

        if (app.settings.isDesktop) {
            this.resources['video'] = app.staticPath + 'img/IndexMoments/fireworks.mp4';
        } else {
            this.resources['photo'] = app.staticPath + 'img/IndexMoments/fireworks.jpg';
        }

        if (!app.settings.isPhone) {
            this.resources['left-bush'] = app.staticPath + 'img/IndexMoments/left-bush.png';
            this.resources['right-bush'] = app.staticPath + 'img/IndexMoments/right-bush.png';
        }

        if (Modernizr.webgl && !Modernizr.ieany && app.settings.isDesktop) {
            this.effectLevel = 'webgl';

            this.resources['city'] = app.staticPath + 'img/IndexMoments/city' + deviceSuffix + '.png';
            this.resources['depth_map'] = app.staticPath + 'img/IndexMoments/depth_map' + deviceSuffix + '.jpg';
            this.resources['depth_map_color'] = app.staticPath + 'img/IndexMoments/depth_map_color' + deviceSuffix + '.jpg';
        } else {
            this.effectLevel = 'photo';

            this.resources['city'] = app.staticPath + 'img/IndexMoments/city' + deviceSuffix + '.png';
        }

        this.on('resources-ready', this.onResourcesReady);

        IndexSection.prototype.initialize.call(this, options);
    },


    onResourcesReady: function() {

        this.dx = 0;
        this.dy = 0;

        if (this.resources['video']) {
            var $video = $('<video class="IndexMoments-video" width="100%" height="" muted playsinline crossorigin loop preload="auto"></video>');
            $video.attr('src', this.resources['video']);
            this.$('.IndexMoments-fireworks').append($video);
            this.video = $video.get(0);
        } else {
            this.$('.IndexMoments-fireworks').css({
                'background-image': 'url(' + this.resources['photo'] + ')',
                'background-size': 'cover',
                'background-position': '50% 100%',
                'bottom': '40%'
            });
        }

        this.waterHandler = this.initWater();
        this.paralaxHandler = this.initParallax();

        this.bushHandlerLeft = this.initBush({
            $container: this.$('.IndexMoments-leftImageWrapper'),
            image: this.resources['left-bush'],
            w: 710,
            h: 384
        });

        this.bushHandlerRight = this.initBush({
            $container: this.$('.IndexMoments-rightImageWrapper'),
            image: this.resources['right-bush'],
            w: 729,
            h: 445
        });

        // Firefox doesn't support looping video, so we emulate it this way
        this.video && this.video.addEventListener('ended', function () {
            this.video.play();
        }.bind(this), false);
    },


    show: function (params) {
        IndexSection.prototype.show.call(this, params);
        this.onResize();

        this.paralaxHandler.resume();


        if (this.video) {
            console.log('show', this.videoReady, this.video.readyState);

            if (this.videoReady || this.video.readyState === 3 || this.video.readyState === 4)  {
                this.video.play();
                this.videoReady = true;
            } else {
                $(this.video).on('canplay', this.onVideoCanPlay);
                $(this.video).on('canplaythrough', this.onVideoCanPlay);
            }
        }

        this.waterHandler.resume();
        this.bushHandlerLeft.resume();
        this.bushHandlerRight.resume();

        $(window).on('resize', this.onResize);
    },


    hide: function (params) {
        IndexSection.prototype.hide.call(this, params);
    },


    onHideEnd: function(params) {
        this.paralaxHandler.pause();

        if (this.video) {
            console.log('onHideEnd', this.videoReady, this.video.readyState);

            if (this.videoReady) {
                this.video.pause();
            } else {
                $(this.video).off('canplay', this.onVideoCanPlay);
                $(this.video).off('canplaythrough', this.onVideoCanPlay);
            }
        }
        this.waterHandler.pause();
        this.bushHandlerLeft.pause();
        this.bushHandlerRight.pause();

        $(window).off('resize', this.onResize);
    },


    onVideoCanPlay: function() {
        console.log('onVideoCanPlay', this.video.readyState);

        $(this.video).off('canplay', this.onVideoCanPlay);
        $(this.video).off('canplaythrough', this.onVideoCanPlay);

        this.videoReady = true;

        this.video.play();
    },


    onResize: function () {
        this.bushWidth = this.$('.IndexMoments-bush').width();
        this.cityWidth = this.$('.IndexMoments-city').width();
        this.videoWidth = this.$('.IndexMoments-fireworks').width();
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    },


    initWater: function () {

        if (this.effectLevel == 'photo') {
            this.$('.IndexMoments-cityBg').css('background-image', 'url(' + this.resources['city'] + ')');

            return {
                resume: function () {},
                pause: function () {}
            };
        }

        // var w = window.innerWidth, h = window.innerHeight;
        var self = this;
        var containerW;
        var containerH;
        var d;
        var color_d;
        var f;
        var fg;
        var shader;
        var imageW = 2100;
        var imageH = 820;

        if (app.settings.isTablet) {
            imageW = 1600;
            imageH = 625;
        }

        if (app.settings.isPhone) {
            imageW = 1000;
            imageH = 390;
        }

        var $fireworks = this.$('.IndexMoments-fireworks');

        resizeRenderer();

        var renderer = new PIXI.autoDetectRenderer(imageW, imageH, {transparent: true});
        var cOutput = document.getElementById('IndexMoments-city');
        cOutput.appendChild(renderer.view);

        var stage = new PIXI.Container();
        var container = new PIXI.Container();
        var foreground = new PIXI.Container();

        stage.addChild(container);
        stage.addChild(foreground);

        var animationFrame;


        var shaderData = [
            'precision mediump float;',
            'uniform float u_time;',
            'varying vec2 vTextureCoord;',
            'uniform sampler2D uSampler;',
            'uniform sampler2D u_maps;',
            'uniform vec2 u_mapsSize;',
            'uniform vec2 u_mouse;',
            'uniform float u_dpi;',
            'uniform vec2 u_resolution;',
            'uniform vec4 filterArea;',
            'vec2 pixel(){',
            'return vec2(1.0*u_dpi)/u_resolution;',
            '}',
            'float wave(float x,float freq, float speed){',
            'return sin(x*freq+((u_time*(3.1415/2.0))*speed));',
            '}',
            'vec2 waves(vec2 pos){',
            'vec2 mappedCoord = pos * filterArea.xy / u_mapsSize;',
            'vec4 maps=texture2D(u_maps,mappedCoord);',
            'float mask=maps.r;',
            'float y=maps.g - 0.05;',
            'float y2=pow(y,2.0);',
            'vec2 intensity=vec2(',
            '0.1 + y2 * 2.0,',
            'y2 * 4.0',
            ')*pixel();',
            'vec2 waves=vec2(',
            'wave(y,400.0-(y2*200.0),-0.03),',
            'wave(y,400.0-(y2*400.0*0.05),-0.045)',
            '+wave(y,900.0-(y2*900.0*0.05),-0.05)',
            '+wave(pos.x,20.0+(y2*20.0*1.5),-0.01)',
            ');',
            'return pos+(waves*intensity*mask);',
            '}',
            'void main(){',
            'vec2 turbulence=waves(vTextureCoord);',
            'vec4 c=texture2D(uSampler,turbulence);',
            'gl_FragColor=c;',
            '}',
        ].join('\n');

        $(window).on('resize', resizeRenderer);


        fg = new PIXI.Sprite.fromImage(this.resources['city']);
        foreground.addChild(fg);

        d = new PIXI.Sprite.fromImage(this.resources['depth_map']);
        color_d = new PIXI.Texture.fromImage(this.resources['depth_map_color']);
        f = new PIXI.filters.DisplacementFilter(d, 0);

        //shader initial settings
        var uniforms = {};
        uniforms.u_time = {type: 'float', value: 1.0};
        uniforms.u_maps = {type: "sampler2d", value: color_d};
        uniforms.u_dpi = {type: 'float', value: 2.0};
        uniforms.u_resolution = {type: 'vec2', value: {x: containerW, y: containerH}};
        uniforms.u_mapsSize = {type: 'vec2', value: {x: imageW, y: imageH}};

        //create shader
        shader = new PIXI.Filter(null, shaderData, uniforms);

        //apply shader
        fg.filters = [f, shader];


        resizeRenderer();


        return {
            resume: function () {
                cancelAnimationFrame(animationFrame);

                animate();
            },

            pause: function () {
                cancelAnimationFrame(animationFrame);
            }
        };



        function resizeRenderer() {
            var ratio = imageW / imageH; //images ratio
            var ww = window.innerWidth * 1.02;
            var wh = window.innerHeight * 495 / 800; //percentage height from window

            if (ww / wh < ratio) {
                containerW = wh * ratio;
                containerH = wh;
            } else {
                containerW = ww;
                containerH = ww / ratio;
            }

            if (renderer) {
                renderer.view.style.width = containerW + 'px';
                renderer.view.style.height = containerH + 'px';
            }

            shader && (shader.uniforms.u_resolution = {x: containerW, y: containerH});

            var cityTransparentHeight = containerH * 270 / 820;
            var cityTop = window.innerHeight * (800 - 495) / 800;
            var transparentTop = cityTop + cityTransparentHeight;

            $fireworks.css('bottom', window.innerHeight - transparentTop);
        }


        function animate() {
            animationFrame = requestAnimationFrame(animate);

            if (f) {
                // f.scale.x = -(window.innerWidth / 2 - mousex) / 150;
                // f.scale.y = -(window.innerHeight / 2 - mousey) / 150;
                if (app.settings.isDesktop) {
                    f.scale.x = self.dx * 8;
                    f.scale.y = self.dy * 8;
                } else {
                    f.scale.x = self.dx * 14;
                    f.scale.y = self.dy * 14;
                }
            }

            if (shader) {
                shader.uniforms.u_time += 0.45;
            }

            if (renderer) {
                renderer.render(stage);
            }
        }
    },


    initBush: function (params) {

        if (this.effectLevel == 'photo' || !params.image) {
            if (params.image) {
                var $bush = $('<img alt="bush" class="IndexMoments-bushImg">');
                $bush.attr('src', params.image);
                params.$container.append($bush);
            }

            return {
                resume: function () {},
                pause: function () {}
            };
        }

        var self = this;
        var animationFrame;
        var shader;

        var shaderData = [
            'precision mediump float;',

            'uniform float u_time;',
            'varying vec2 vTextureCoord;',
            'uniform sampler2D uSampler;',

            'float wave(float x,float freq, float speed){',
                'return sin(x*freq+((u_time*(3.1415/2.0))*speed));',
            '}',

            'vec2 waves(vec2 pos){',
                'float y2=pow(pos.y,2.0);',
                'vec2 intensity=vec2(0.003 * (1.0 - pos.y),0.005);',
                'vec2 waves=vec2(',
                    'wave(pos.x,10.0-(y2*5.0),-0.052)*0.7 + wave(pos.x,7.0-(y2*2.0),-0.03)*0.7 + wave(pos.y,3.0-(y2*1.0),-0.04) * 0.4,',
                    'wave(pos.y,8.0-(y2*2.5),-0.025)',
                ');',
                'return pos+waves*intensity;',
            '}',
            'void main(){',
                'vec2 turbulence=waves(vTextureCoord);',
                'vec4 c=texture2D(uSampler,turbulence);',
                'gl_FragColor=c;',
            '}',
        ].join('\n');

        var renderer = new PIXI.autoDetectRenderer(params.w, params.h, {transparent: true});
        params.$container.append(renderer.view);

        var stage = new PIXI.Container();

        var bush = new PIXI.Sprite.fromImage(params.image);
        stage.addChild(bush);

        //shader initial settings
        var uniforms = {};
        uniforms.u_time = {type: 'float', value: 1.0};

        //create shader
        shader = new PIXI.Filter(null, shaderData, uniforms);

        stage.filters = [shader];


        return {
            resume: function () {
                cancelAnimationFrame(animationFrame);

                animate();
            },

            pause: function () {
                cancelAnimationFrame(animationFrame);
            }
        };


        function animate() {
            animationFrame = requestAnimationFrame(animate);

            var xBushShift = self.dx * (self.bushWidth - self.windowWidth - 4) * 3;
            var yBushShift = self.dy * (self.bushWidth - self.windowWidth - 4);

            if (!app.settings.isDesktop) {
                xBushShift *= 2.5;
                yBushShift *= 2.5;
            }

            bush.x = xBushShift;
            bush.y = yBushShift;

            if (shader) {
                shader.uniforms.u_time += 0.85;
            }

            if (renderer) {
                renderer.render(stage);
            }
        }
    },


    initParallax: function () {

        var animationFrameId, stopTimeout,
            dxTarget = 0,
            prevX,
            dx = 0,
            dyTarget = 0,
            dy = 0,
            inertion = 0,
            tracking = false,
            self = this;


        return {
            resume: function () {
                if (app.settings.isDesktop) {
                    $('body').on('mouseenter', startTracking);
                    $('body').on('mouseleave', stopTracking);
                    $('body').on('mousemove', mousePosChanged);
                } else {
                    window.addEventListener('deviceorientation', orientationChanged, false);
                    startTracking();
                }
            },

            pause: function () {
                stopTracking();

                if (app.settings.isDesktop) {
                    $('body').off('mouseenter', startTracking);
                    $('body').off('mouseleave', stopTracking);
                    $('body').off('mousemove', mousePosChanged);
                } else {
                    window.removeEventListener('deviceorientation', orientationChanged, false);
                }
            }
        };


        function startTracking() {
            tracking = true;

            clearTimeout(stopTimeout);
            window.cancelAnimationFrame(animationFrameId);

            inertion = 0;
            applyParalax();

            function applyParalax() {
                dx += (dxTarget - dx) * inertion;
                dy += (dyTarget - dy) * inertion;

                self.dx = dx;
                self.dy = dy;

                inertion = Math.min(inertion + 0.01, 0.1);

                var xBushShift = -dx * (self.bushWidth - self.windowWidth - 4) * 3;
                var xCityShift = dx * (self.cityWidth - self.windowWidth - 4) / 3;
                var xVideoShift = -dx * (self.videoWidth - self.windowWidth - 4) / 5;


                var yBushShift = -dy * (self.bushWidth - self.windowWidth - 4);
                var yCityShift = dy * (self.cityWidth - self.windowWidth - 4) / 8;
                var yVideoShift = -dy * (self.videoWidth - self.windowWidth - 4) / 7;

                if (!app.settings.isDesktop) {
                    xBushShift *= 1.5;
                    yBushShift *= 1.5;
                }

                if (app.settings.isTablet) {
                    xVideoShift *= 4;
                    yVideoShift *= 4;
                    xCityShift *= 1.5;
                    xCityShift *= 1.5;
                }

                if (app.settings.isPhone) {
                    xVideoShift *= 8;
                    yVideoShift *= 8;
                }


                if (self.effectLevel == 'photo') {
                    self.$('.IndexMoments-leftBush, .IndexMoments-rightBush').css({
                        'transform': 'translate3d(' + -Math.round(xBushShift * 10) / 10 + 'px, ' + -Math.round(yBushShift * 10) / 10 + 'px, 0)'
                    });

                    self.$('.IndexMoments-city').css({
                        'transform': 'translate(' + Math.round(xCityShift * 10) / 10 + 'px, ' + Math.round(yCityShift * 10) / 10 + 'px)'
                    });
                }


                self.$('.IndexMoments-fireworks').css({
                    'transform': 'translate(' + -Math.round(xVideoShift * 10) / 10 + 'px, ' + Math.round(yVideoShift * 10) / 10 + 'px)'
                });

                animationFrameId = window.requestAnimationFrame(applyParalax);
            }
        }


        function stopTracking() {
            // dxTarget = 0;
            // inertion = 0;

            // tracking = false;

            // stopTimeout = setTimeout(function(){
            //     window.cancelAnimationFrame(animationFrameId);
            // }, 1000);

            inertion = 0;
            tracking = false;
            window.cancelAnimationFrame(animationFrameId);
        }


        function orientationChanged(e) {
            switch (window.orientation) {
                case 0:
                    dyTarget = -(.02 * e.beta - .25 * Math.PI);
                    dxTarget = .03 * -e.gamma;
                    break;
                case 90:
                    dyTarget = -(.02 * -e.gamma - .25 * Math.PI);
                    dxTarget = .04 * -e.beta;
                    break;
                case -90:
                    dyTarget = -(.02 * e.gamma - .25 * Math.PI);
                    dxTarget = .04 * e.beta;
            }

            dyTarget > .8 ? dyTarget = .8 : dyTarget < -.8 && (dyTarget = -.8);
            dxTarget > .8 ? dxTarget = .8 : dxTarget < -.8 && (dxTarget = -.8);
            dy = dyTarget;
            dx = dxTarget;
        }


        function mousePosChanged(e) {
            dxTarget = e.pageX / (self.windowWidth / 2) - 1;
            dyTarget = e.pageY / (self.windowHeight / 2) - 1;

            prevX = e.pageX;

            if (!tracking) {
                startTracking();
            }
        }
    },
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexMoments/IndexMoments.js
 ** module id = 18
 ** module chunks = 0
 **/